import { defineComponent, h, onBeforeUnmount, onMounted, ref, watch } from '@vue/composition-api';
/** 监控并反馈区块DOMRect数据的相关逻辑 */
const useBlockRect = (ctx) => {
  /** 区块引用 */
  const blockRef = ref();
  /** resize事件回调函数 */
  const onResize = () => {
    if (blockRef.value !== null) {
      const rect = blockRef.value.getBoundingClientRect();
      ctx.emit('rect:update', rect);
    }
  };
  watch(() => blockRef.value, next => {
    if (next !== null) {
      // 初始化
      setTimeout(onResize,200)
    }
  });
  onMounted(() => {
    // 添加 resize 事件监听
    window.addEventListener('resize', () => {
      setTimeout(onResize,200)
    });
  });
  onBeforeUnmount(() => {
    // 移除 resize 事件监听
    window.removeEventListener('resize', () => {
      setTimeout(onResize,200)
    });
  });
  return { blockRef };
};
export default defineComponent({
  name: 'KrCard',
  props: {
    /** 标题 */
    title: {
      type: String,
    },
    /** 高度 */
    height: {
      type: [Number, String],
    },
    /** 宽度 */
    width: {
      type: Number,
    },
    titleSize: {
      type: String,
      default: 'default',
    },
    padding: {
      type: [Number, Array],
      default: () => [0, 16, 0, 16],
    },
    /** 内容区容器自定义样式类名 */
    bodyClass: {
      type: String,
      default: '',
    },
    /**
     * 用于辅助控制(纵向)滚动条出现在卡片容器内部
     */
    overflowInBody: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const id = ref(0);
    const loading = ref(false);
    return {
      id,
      loading,
      ...useBlockRect(ctx),
    };
  },
  render() {
    const children = [];
    const title = this.title;
    const paddingList = Array.isArray(this.padding)
      ? this.padding
      : [this.padding, this.padding, this.padding, this.padding];
    const padding = paddingList ? paddingList.length === 2 ? [...paddingList, ...paddingList] : paddingList:[0,0,0,0];
    const style = {
      ...(this.height
        ? typeof this.height === 'number'
          ? { height: `${this.height}px` }
          : { height: this.height }
        : {}),
      ...(this.width ? { width: `${this.width}px` } : {}),
      padding: padding.map(el => `${el}px`).join(' '),
    };
    if (this.$slots.title !== undefined) {
      children.push(h('div', { class: ['tg-card-hd'] }, [this.$slots.title]));
    }
    else if (title !== '') {
      children.push(h('div', { class: ['tg-card-hd'] }, [title]));
    }
    return h('div', {
      class: ['tg-card', this.overflowInBody ? 'inner-overflow' : ''],
      style,
      ref: 'blockRef',
    }, [...children, h('div', { class: ['tg-card-bd', this.bodyClass] }, [this.$slots.default])]);
  },
});
//# sourceMappingURL=card.js.map
